// Use environment variable for API base URL
// For production, set REACT_APP_API_BASE_URL in Netlify environment variables
// For local development, set in .env file or defaults to localhost:8080
const base_url = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

export default base_url;
